import { render, staticRenderFns } from "./CreateNota.vue?vue&type=template&id=72f6a62b&"
import script from "./CreateNota.vue?vue&type=script&lang=js&"
export * from "./CreateNota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports